<template>
  <div>
    <div class="moment-item-box">
      <ItemActionStatsEmit
        :delay="15000"
        :itemId="itemId"
        itemType="moment"
        :key="itemId"
        action="view"
        v-if="itemId && !isLoading"
      ></ItemActionStatsEmit>
      <div v-if="isLoading" class="loading-box">
        <LoadingComponent> </LoadingComponent>
      </div>
      <div v-if="itemInfo">
        <Swipe class="img-container" v-if="itemInfo.images">
          <SwipeItem
            v-for="img in itemInfo.images"
            v-if="itemInfo.images"
            :key="img.uri"
          >
            <div class="img-item">
              <img :src="img.url" />
            </div>
          </SwipeItem>
        </Swipe>

        <div class="content-box">
          <div class="title" v-if="itemInfo.title">{{ itemInfo.title }}</div>
          <div class="desc-box">
            <div class="description">{{ itemInfo.description }}</div>

            <div v-if="itemInfo.mem_locked" class="vip-box">
              <div class="mask"></div>
              <div class="container-vip" @click="onToVip">
                <div class="tip-text">开通会员 查看完整内容 ></div>
                <div class="img-box">
                  <img
                    src="http://a1.yujianquancheng.com/wtos/public/1c36f55d03580a0e.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="collection-action" v-if="itemInfo.collection_base">
          <CollectionBase
            :currentItemId="itemId"
            :collectionBase="itemInfo.collection_base"
            @onChange="onChangeItem"
          ></CollectionBase>
        </div>
        <div class="topic-container" v-if="itemInfo.topic_list && itemInfo.topic_list.length > 0">
          <div
            class="topic-item"
            v-for="topicItem in itemInfo.topic_list"
            @click="toTopicDetail(topicItem)"
          >
            # {{ topicItem.name }}
          </div>
        </div>

        <div>
          <Popup
            v-model="showPay"
            closeable
            close-icon="close"
            class="pay-container"
          >
            <VipCashier v-if="showPay"></VipCashier>
          </Popup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popup, Swipe, SwipeItem } from "vant";
import TopNavbar from "@/components/common/TopNavbar.vue";
import LoadingComponent from "@/components/common/LoadingComponent.vue";
import ItemActionStatsEmit from "@/components/common/ItemActionStatsEmit.vue";
import VipCashier from "@/components/cashier/VipCashier.vue";
import CollectionBase from "@/components/collection/CollectionBase.vue";

export default {
  components: {
    Swipe,
    SwipeItem,
    Popup,
    TopNavbar,
    ItemActionStatsEmit,
    LoadingComponent,
    VipCashier,
    CollectionBase,
  },
  props: {
    itemId: {},
  },
  name: "MomentStoryDetail",
  data() {
    return {
      itemInfo: null,
      isLoading: false,
      refer: "",
      showPay: false,
    };
  },
  mounted() {},
  activated() {},
  methods: {
    onChangeItem(itemId) {
      this.$emit("changeItem", itemId);
    },

    async getItemInfo() {
      let params = {
        id: this.itemId,
      };
      this.isLoading = true;
      await this.$store.dispatch("GetUgcItem", params).then(
        (data) => {
          if (data.code == 0) {
            this.itemInfo = data.data;
          }
        },
        () => {
          console.log("error");
        }
      );
      this.isLoading = false;
    },

    onToVip() {
      this.showPay = true;
      return;
    },

    toTopicDetail(topicItem) {
      this.$router.push({
        path: `/topic/${topicItem.id}`,
      });
    },
  },
  computed: {},
  watch: {
    itemId: {
      handler: function() {
        if (!this.itemId) {
          return;
        }
        this.getItemInfo();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.moment-item-box {
  padding-bottom: 50px;
  padding-top: 52px;
}

.loading-box {
  height: 100vh;
}

.img-container {
  .img-item {
    display: flex;
    width: 100%;
    max-height: 80vh;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.user-container {
  margin: 16px 18px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .btn-follow {
    padding: 8px 16px;
    border-radius: 20px;
    background-color: #f2f2f2;
  }
}

.content-box {
  padding: 8px 22px;
  .title {
    font-size: 20px;
    font-weight: bold;
    line-height: 2;
    padding: 12px 0;
  }

  .desc-box {
    position: relative;
  }

  .description {
    position: relative;
    line-height: 2;
    font-size: 20px;
    white-space: pre-line;
  }

  .container-vip {
    width: 100%;
    z-index: 10;
    padding-top: 60px;
    position: relative;
    top: -40px;
    background: linear-gradient(to top, #fff 80%, #ffffff5e);

    .tip-text {
      margin-bottom: 12px;
      text-align: center;
      color: rgb(140, 80, 3);
      
    }

    .img-box {
      margin-top: 8px;
    }

    img {
      width: 100%;
    }
  }

  .btn-vip {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 20px;
    background-color: rgb(152, 98, 28);
    color: #fff;
    border-radius: 5px;
    font-size: 16px;
    text-align: center;
    z-index: 11;
  }
}

.topic-container {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 18px;

  .topic-item {
    margin-right: 16px;
    margin-top: 8px;
    font-size: 16px;
    color: rgb(3, 3, 67);
  }
}

.comment-cell {
  margin-top: 12px;
  border-top: 1px solid #f2f2f2;
  .comment-title {
    padding: 18px;
    font-size: 18px;
  }
}

.bottom-action-container {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.bottom-action-list {
  padding: 12px 18px;
  border-top: 1px solid #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;

  .input-logo {
    flex: 1 1 auto;
    height: 100%;

    .input-box {
      -webkit-border-radius: 25px;
      -moz-border-radius: 25px;
      border-radius: 25px;
      background: rgba(225, 226, 227, 0.55);
      color: rgba(135, 143, 145, 0.89);
      font-size: 12px;
      padding: 0 15px;
      line-height: 3;
    }
  }

  .action-item {
    flex: 0 0 auto;
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    .desc {
      // margin-left: 5px;
      font-size: 14px;
      color: #333;
      margin-left: 5px;
    }
  }
}

.collection-action {
  margin: 15px 12px;
  border-radius: 8px;
  overflow: hidden;
}

.pay-container {
  min-width: 80vw;
  max-height: 90vh;
  overflow: scroll;
}
</style>
